import { createStatic } from 'styled-components-breakpoint';
export var breakpointObj = {
  phone: 0,
  phoneLarge: 480,
  tabletPortrait: 600,
  tabletIpadPortrait: 768,
  tabletLandscape: 960,
  desktop: 1280,
  giant: 1920
};
var breakpoints = createStatic(breakpointObj);
var map = breakpoints.map;
export { map };
export default breakpoints;